import * as types from './types';

const initialState = {
  lastStep: null,
  getLastStepError: false,
  currentStep: '1',
  preventTransition: false,
  nextStepperRoute: null,
  stepperFormRef: null,
  loadingStepperState: true,
  snackAction: { action: '', result: '' }
};

function stepperReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_POSTING_LAST_STEP:
      return {
        ...state,
        getLastStepError: false,
        loadingStepperState: true
      };
    case types.GET_POSTING_LAST_STEP_COMPLETED:
      return {
        ...state,
        lastStep: action.payload.step,
        loadingStepperState: false
      };
    case types.GET_POSTING_LAST_STEP_FAILED:
      return {
        ...state,
        getLastStepError: true,
        loadingStepperState: false
      };
    case types.SET_CURRENT_STEP:
      return {
        ...state,
        currentStep: action.payload
      };
    case types.SET_PREVENT_TRANSITION:
      return {
        ...state,
        preventTransition: action.payload
      };
    case types.SET_NEXT_STEPPER_ROUTE:
      return {
        ...state,
        nextStepperRoute: action.payload
      };
    case types.SET_STEPPER_FORM_REF:
      return {
        ...state,
        stepperFormRef: action.payload
      };
    case types.UPDATE_LAST_STEP: {
      // actualizo manualmente el ultimo paso, siempre y cuando sea mayor al ultimo cargado en el back ( edicion )
      return { ...state, lastStep: action.payload.step > state.lastStep ? action.payload.step : state.lastStep };
    }

    case types.SET_SNACKBAR:
      return {
        ...state,
        snackAction: action.payload
      };

    default:
      return state;
  }
}

export { stepperReducer };
